import { eventPhase, EventTimes } from './event-edit-lock'

/** The state badge a manager sees on an event. */
export type EventState = 'ONGOING' | 'DISABLED' | 'SCHEDULED' | 'COMPLETED' | 'CANCELED'

/**
 * A cancel wins over everything: a cancelled event stays `CANCELED` after its time has passed (docs/events.md,
 * _Cancelling an event_). Then time wins over the sign-up lock: an ended event is `COMPLETED` and a running one
 * `ONGOING` whether or not sign-up is locked. Only an upcoming event shows `DISABLED` for a lock.
 */
export function eventState(
  event: EventTimes & { active: boolean; cancelledAt?: Date | string | null },
  now: Date,
  timezone: string,
): EventState {
  if (event.cancelledAt) {
    return 'CANCELED'
  }
  const phase = eventPhase(event, now, timezone)
  if (phase === 'ended') {
    return 'COMPLETED'
  }
  if (phase === 'ongoing') {
    return 'ONGOING'
  }
  return event.active ? 'SCHEDULED' : 'DISABLED'
}
